import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StepOneMauticComponent } from 'src/components/step-one-mautic/step-one-mautic.component';
import { StepTwoMauticComponent } from 'src/components/step-two-mautic/step-two-mautic.component';
import { FinishMauticComponent } from 'src/components/finish-mautic/finish-mautic.component';
import { SendRecoveryPasswordMauticComponent } from 'src/components/send-recovery-password-mautic/send-recovery-password-mautic.component';
import { StepCompanyBasicInfoMauticComponent } from 'src/components/step-company-basic-info-mautic/step-company-basic-info-mautic.component';
import { StepCompanyContactMauticComponent } from 'src/components/step-company-contact-mautic/step-company-contact-mautic.component';
import { StepCompanySocialMauticComponent } from 'src/components/step-company-social-mautic/step-company-social-mautic.component';
import { StepThreeMauticComponent } from 'src/components/step-three-mautic/step-three-mautic.component';
import { StepFourMauticComponent } from 'src/components/step-four-mautic/step-four-mautic.component';
import { ProgressMauticComponent } from 'src/components/progress-mautic/progress-mautic.component';

const routes: Routes = [
    { path: 'mautic-form/step-one', component: StepOneMauticComponent },
    { path: 'mautic-form/step-two', component: StepTwoMauticComponent },
    { path: 'mautic-form/step-three', component: StepThreeMauticComponent },
    { path: 'mautic-form/step-four', component: StepFourMauticComponent },
    { path: 'mautic-form/finish', component: FinishMauticComponent },
    { path: 'mautic-form/send-recovery', component: SendRecoveryPasswordMauticComponent },
    { path: 'mautic-form/step-company-basic-info', component: StepCompanyBasicInfoMauticComponent },
    { path: 'mautic-form/step-company-contact', component: StepCompanyContactMauticComponent },
    { path: 'mautic-form/step-company-social', component: StepCompanySocialMauticComponent },
    { path: 'mautic-form/progress', component: ProgressMauticComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class MauticRoutingModule { }
